/** Reine Chat-Texte für abgeschlossene Hintergrundanalysen — kein Fetch, kein Fake. */

const BACKGROUND_ANALYSIS_SUMMARY_SENTENCES = 6;
const NO_ANALYSIS_REPLY =
  'Der Worker hat keinen Auswertungstext geliefert. Bitte die Analyse erneut starten, falls der Inhalt fehlt.';

/** Fallback im Popover, bevor n/needed da ist — nicht „nur Kopf forever“. */
export const BACKGROUND_ANALYSIS_CAP_HINT =
  'needed = ceil(Extract-Zeichen / 7500), max. 24 Abschnitte. Fortschritt n/needed plus Zeichen gelesen/gesamt. Kein Vollgutachten aus einem Fenster.';

/** Mini-Auftrag ohne Parent-Chatverlauf (frisches Fenster). */
export const BACKGROUND_DOCUMENT_ANALYSIS_PROMPT =
  'Dokumentanalyse (frisches Fenster): Nur das mitgelieferte Extract-Fenster auswerten. Kein Vollgutachten über ungelesene Teile. Kernaussagen, offene Punkte, sichtbare Absätze. Keine LEXCORE-/OGH-/Web-Recherche. Nichts erfinden.';

export const BACKGROUND_DOCUMENT_ANALYSIS_SYNTHESIS_PROMPT =
  'Dokumentanalyse Synthese (frisches Fenster): Die Notizen aus den gelesenen Abschnitten zu einer Gesamtsicht zusammenfassen. Ungelesenen Rest ehrlich nennen. Kein Vollgutachten über ungelesene Teile. Keine LEXCORE-/OGH-/Web-Recherche. Nichts erfinden.';

function splitReplySentences(text: string): string[] {
  return text
    .split(/(?<=[.!?])(?:[ \t]+|\n+)/)
    .map((part) => part.trim())
    .filter(Boolean);
}

/** Kurzzusammenfassung aus dem Worker-Text — kein Fake, nur vorhandener Reply. */
export function splitBackgroundAnalysisReply(reply: string): { summary: string; details: string | null } {
  const cleaned = reply.trim();
  if (!cleaned) return { summary: NO_ANALYSIS_REPLY, details: null };
  const sentences = splitReplySentences(cleaned);
  if (sentences.length === 0) return { summary: NO_ANALYSIS_REPLY, details: null };
  if (sentences.length <= BACKGROUND_ANALYSIS_SUMMARY_SENTENCES) {
    return { summary: cleaned, details: null };
  }
  return {
    summary: sentences.slice(0, BACKGROUND_ANALYSIS_SUMMARY_SENTENCES).join(' '),
    details: cleaned,
  };
}

export interface BackgroundAnalysisChatContent {
  text: string;
  messageKind: 'background_analysis';
  backgroundAnalysis: {
    documentName: string;
    details: string | null;
  };
}

export function buildBackgroundAnalysisChatContent(
  documentName: string,
  reply: string,
  coverageHint?: string | null,
): BackgroundAnalysisChatContent {
  const label = documentName.trim() || 'Dokument';
  const { summary } = splitBackgroundAnalysisReply(reply);
  const hint = coverageHint?.trim() || BACKGROUND_ANALYSIS_CAP_HINT;
  return {
    text:
      `Hintergrundanalyse zu „${label}“ abgeschlossen.\n\n${summary}\n\n`
      + `${hint} Volltext und Abschnittsnotizen im Analyse-Chip.`,
    messageKind: 'background_analysis',
    backgroundAnalysis: {
      documentName: label,
      // Polar: Worker-Text nicht in den Hauptchat kippen — nur Handshake.
      details: null,
    },
  };
}
